import * as api from "../../api/smsRegistrations";
import * as flagApi from "../../api/featureFlags";
import get from 'lodash.get';
import {buildCampaignObject, buildBulkSmsCampaignObject,supportMessagingDescriptionV2,isSPAccountsAccessible} from '../../helpers/functions';
import { getAccountCatalog, getPaymentMethods } from '../../api/billing';
import { getDefaultPaymentMethod, getBrandCatalogRatePlanId, getCampaignCatalogRatePlanId, buildBillingObject } from '../../helpers/billing/functions';
import {APPROVED_REGISTRATION_STATUS, REGISTRATION_STATUS} from '../../helpers/smsRegisrtration/constants';
import { EDIT_FORM_VIEW_TYPE } from '../../components/smsRegistrationComponents/EditRegistrationForm.vue';
import { BRAND_ENTITY_TYPES } from "../../helpers/smsRegisrtration/constants";
const actions = {
  async fetchAccountRegistrationStatus({ rootState, commit, state, dispatch }) {
    const credentials = rootState.credentials;
    const { data: quickFlowResponse } = await api.getQuickFlowStatus(credentials);
    if (quickFlowResponse) {
      commit('ACCOUNT_PERFORMED_REGISTRATION', true);
      commit('ACCOUNT_REGISTRATION_RESPONSE', quickFlowResponse);
      commit('ACCOUNT_FOLLOWER_ACCOUNT', quickFlowResponse);
      if (quickFlowResponse.status === REGISTRATION_STATUS.BILLING_BRAND_PURCHASED_NEED_RESUBMIT || quickFlowResponse.status === REGISTRATION_STATUS.BRAND_DELETED) {
        commit('ACCOUNT_NEED_RESUBMIT',true)
      }
      if (APPROVED_REGISTRATION_STATUS.includes(quickFlowResponse.status)) {
        const isSoleProprietor = quickFlowResponse?.vonage_api_brand_request?.entity_type === 'SOLE_PROPRIETOR';
        const isSubAccount = typeof quickFlowResponse?.main_account_id === 'string';

        let canEdit = !isSubAccount;

        if (isSoleProprietor) {
          await dispatch('checkSpEditFlagForUser');
          canEdit = canEdit && state.soleProprietorEditEnabled;
        }

        commit('SET_VOLUNTARY_EDIT_ENABLED', canEdit);
      }
    } else {
      commit('ACCOUNT_PERFORMED_REGISTRATION', false);
    }
  },

  async fetchMainAccountRegistration({ rootState, commit }) {
    const credentials = rootState.credentials;
    const { data: mainAccountResponse } = await api.getMainAccountRegistration(credentials);
    if (mainAccountResponse) {
      commit('MAIN_ACCOUNT_REGISTRATION_RESPONSE', mainAccountResponse);
    }
  },
  async submitRegistration({ rootState, dispatch, commit, state }, { registrationDetails, messagingDescription,  messageContent}) {
    commit('CLEAR_REGISTRATION_ERROR');

    const brandObject = {
      company_name: registrationDetails.companyName,
      display_name: registrationDetails.displayName,
      entity_type: registrationDetails.entityType,
      website: registrationDetails.website.trim(),
      vertical: registrationDetails.vertical,
      street: registrationDetails.street,
      city: registrationDetails.city,
      state: registrationDetails.state,
      postal_code: registrationDetails.postalCode,
      country: registrationDetails.country,
      phone: registrationDetails.e164.substring(1), // without '+'
      email: registrationDetails.email,
    };

    if (registrationDetails.entityType === 'SOLE_PROPRIETOR') {
      brandObject.first_name = registrationDetails.firstName;
      brandObject.last_name = registrationDetails.lastName;
      brandObject.mobile_phone = registrationDetails.mobilePhone;
    } else {
      brandObject.ein = registrationDetails.ein;

      if (registrationDetails.entityType === 'PUBLIC_PROFIT') {
        brandObject.stock_exchange = registrationDetails.stockExchange;
        brandObject.stock_symbol = registrationDetails.stockSymbol;
        brandObject.verification_email = registrationDetails.verificationEmail;
      }
    }


    const campaignObject = buildCampaignObject(messagingDescription, messageContent, registrationDetails.companyName, registrationDetails.displayName, registrationDetails.vertical, registrationDetails.volumeType, registrationDetails.entityType)

    const paymentMethods = await getPaymentMethods(rootState.credentials);
    const paymentMethodId = getDefaultPaymentMethod(paymentMethods.data).id;
    const accountCatalog = await getAccountCatalog(rootState.credentials);
    const campaignCatalogRatePlanId = getCampaignCatalogRatePlanId(accountCatalog.data, registrationDetails.entityType === 'SOLE_PROPRIETOR');
    const brandCatalogRatePlanId = getBrandCatalogRatePlanId(accountCatalog.data);
    const isMultiLocationAccount = rootState.accountDetails.Locations.length > 1;
    const brandBillingObj = buildBillingObject(rootState.accountDetails, rootState.credentials.accountId, isMultiLocationAccount, get(brandCatalogRatePlanId, 'productRatePlanId'), paymentMethodId);
    const campaignBillingObj = buildBillingObject(rootState.accountDetails, rootState.credentials.accountId, isMultiLocationAccount, get(campaignCatalogRatePlanId, 'productRatePlanId'), paymentMethodId);

    const registrationResponse = state.registrationResponse;
    supportMessagingDescriptionV2(messagingDescription);
    if (registrationResponse && registrationResponse.status === REGISTRATION_STATUS.BILLING_BRAND_PURCHASED_NEED_RESUBMIT) {
      await api.updateAccountRegistration(rootState.credentials, {
        campaign_request: campaignObject,
        brand_request: brandObject,
        campaign_billing_request: campaignBillingObj,
        brand_billing_request: brandBillingObj,
        messaging_description_page : messagingDescription,
        message_content_page : messageContent
      });
    }
    else if (registrationResponse && registrationResponse.status === 'CANCELED') {
      try {
        await api.reSubmitAccountRegistration(rootState.credentials, {
          campaign_request: campaignObject,
          brand_request: brandObject,
          campaign_billing_request: campaignBillingObj,
          brand_billing_request: brandBillingObj,
          messaging_description_page : messagingDescription,
          message_content_page : messageContent
        });
        let attempts = 0;
        const maxAttempts = 5;
        let statusChanged = false;
        
        while (attempts < maxAttempts && !statusChanged) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          const { data: latestStatus } = await api.getQuickFlowStatus(rootState.credentials);
          if (latestStatus && latestStatus.status !== 'CANCELED') {
            statusChanged = true;
          }
          attempts++;
        }
        
      } catch (error) {
        console.error("Error resubmitting registration:", error);
        throw error;
      }
    }
    else {
      await api.submitRegistration(rootState.credentials, {
        campaign_request: campaignObject,
        brand_request: brandObject,
        campaign_billing_request: campaignBillingObj,
        brand_billing_request: brandBillingObj,
        messaging_description_page : messagingDescription,
        message_content_page : messageContent
      });
    }
    await dispatch('fetchAccountRegistrationStatus');
    commit('ACCOUNT_SUBMIT_REGISTRATION');
  },

  async editBulkSmsCampaign({ rootState, getters, dispatch }, { formData, selectedNumbers }) {
  const registrationResponse = getters.registrationResponse;
  const existingUsecase = registrationResponse?.vonage_api_campaign_request?.usecase;
  const displayName = registrationResponse?.vonage_api_brand_request?.display_name || '';

  const cleanedMdp = Object.entries(formData.messagingDescriptionData || {})
    .reduce((result, [key, value]) => {
      if (value && typeof value === 'object') {
        const hasContent = value.url?.trim() || value.describe?.trim();
        if (!value.isCheck || !hasContent) {
          result[key] = null;
        } else {
          const data = { ...value };
          delete data.isCheck;
          delete data.header;
          delete data.verbalEditEnable;
          result[key] = data;
        }
      } else {
        result[key] = value;
      }
      return result;
    }, {});

  const mdpForCampaign = Object.fromEntries(
    Object.entries(cleanedMdp).filter(([, v]) => v !== null)
  );

  const messageContentPageInfo = registrationResponse?.message_content_page;
  const brandRequest = registrationResponse?.vonage_api_brand_request;

  const campaignObject = buildBulkSmsCampaignObject(
    { 
      ...formData, 
      displayName,
      businessType: formData.messagingDescriptionData?.businessType,
      existingPhone: messageContentPageInfo?.supportPhone || brandRequest?.phone || '',
      existingEmail: messageContentPageInfo?.supportEmail || brandRequest?.email || '',
    },
    existingUsecase,
    mdpForCampaign
  );

  campaignObject.sub_usecases = formData.subUseCases || [];
  const messagingDescriptionPage = { ...cleanedMdp };  
  supportMessagingDescriptionV2(messagingDescriptionPage);

  const messageContentPage = {
    campaignSamples: {
      sample1: formData.sampleMessages?.[0] || '',
      sample2: formData.sampleMessages?.[1] || '',
      sample3: formData.sampleMessages?.[2] || '',
      sample4: formData.sampleMessages?.[3] || '',
      sample5: formData.sampleMessages?.[4] || '',
    },
  };

  const phoneNumbers = (selectedNumbers || []).map(n =>
    n.startsWith('+') ? n.substring(1) : n
  );

  await api.editBulkSmsCampaign(rootState.credentials, {
    campaign_request: campaignObject,
    messaging_description_page: messagingDescriptionPage,
    message_content_page: messageContentPage,
    phone_numbers: phoneNumbers,
  });

  await dispatch('fetchBulkSmsCampaign');
},


  async submitBulkSmsCampaign({ rootState }, { formData, selectedNumbers }) {
    const credentials = rootState.credentials;

    const paymentMethods = await getPaymentMethods(credentials);
    const paymentMethodId = getDefaultPaymentMethod(paymentMethods.data).id;
    const accountCatalog = await getAccountCatalog(credentials);
    const isMultiLocationAccount = rootState.accountDetails.Locations.length > 1;

    const campaignCatalogRatePlanId = getCampaignCatalogRatePlanId(accountCatalog.data, false);
    const campaignBillingObj = buildBillingObject(
      rootState.accountDetails,
      credentials.accountId,
      isMultiLocationAccount,
      get(campaignCatalogRatePlanId, 'productRatePlanId'),
      paymentMethodId
    );

    const campaignFeeCatalogRatePlanId = getCampaignCatalogRatePlanId(accountCatalog.data, false);
    const campaignFeeBillingObj = buildBillingObject(
      rootState.accountDetails,
      credentials.accountId,
      isMultiLocationAccount,
      get(campaignFeeCatalogRatePlanId, 'productRatePlanId'),
      paymentMethodId
    );
    const existingUsecase = rootState.smsRegistrations?.registrationResponse?.vonage_api_campaign_request?.usecase;
    const registrationResponse = rootState.smsRegistrations?.registrationResponse;
    const messageContentPage = registrationResponse?.message_content_page;
    const brandRequest = registrationResponse?.vonage_api_brand_request;

    const campaignRequest = buildBulkSmsCampaignObject(
      { 
        ...formData, 
        displayName: brandRequest?.display_name || '',
        businessType: formData.messagingDescriptionData?.businessType,
        existingPhone: messageContentPage?.supportPhone || brandRequest?.phone || '',
        existingEmail: messageContentPage?.supportEmail || brandRequest?.email || '',
      },
      existingUsecase,
      formData.messagingDescriptionData
    );

    const phoneNumbers = selectedNumbers.map(n =>
      n.startsWith('+') ? n.substring(1) : n
    );

    await api.submitBulkSmsCampaign(credentials, {
      campaign_request: campaignRequest,
      campaign_billing_request: campaignBillingObj,
      campaign_fee_billing_request: campaignFeeBillingObj,
      messaging_description_page: formData.messagingDescriptionData || {},
      message_content_page: {},
      phone_numbers: phoneNumbers,
    });
  },

  async fetchBulkSmsCampaign({ rootState, commit }) {
    commit('FETCH_BULK_SMS_CAMPAIGN');
    try {
      const { data } = await api.getBulkSmsCampaign(rootState.credentials);
      commit('SET_BULK_SMS_CAMPAIGN', data);
    } catch (e) {
      commit('ERROR_BULK_SMS_CAMPAIGN');
    }
  },

  async fetchBulkSmsCampaignNumbers({ rootState, commit }) {
    try {
      const { data } = await api.getBulkSmsCampaignNumbers(rootState.credentials);
      commit('SET_BULK_SMS_CAMPAIGN_NUMBERS', data);
    } catch (e) {
      commit('SET_BULK_SMS_CAMPAIGN_NUMBERS', []);
    }
  },

  async cancelBulkSmsCampaign({ rootState, dispatch }) {
    await api.cancelBulkSmsCampaign(rootState.credentials);
    await dispatch('fetchBulkSmsCampaign');
    await dispatch('fetchBulkSmsCampaignNumbers');
  },

  async updateBulkSmsCampaignNumbers({ rootState }, phoneNumbers) {
    const cleaned = phoneNumbers.map(n =>
      n.startsWith('+') ? n.substring(1) : n
    );
    await api.updateBulkSmsCampaignNumbers(rootState.credentials, cleaned);
  },

  async resubmitSmsRegistration({ state, rootState, commit, dispatch }) {
    const registrationResponse = state.registrationResponse;
    if (registrationResponse.status === REGISTRATION_STATUS.BRAND_CREATED_NOT_VERIFIED_PERMANENTLY || registrationResponse.status === REGISTRATION_STATUS.BRAND_ERROR_IN_CREATION) {
      const credentials = rootState.credentials;
      commit('ACCOUNT_NEED_RESUBMIT',true)
      await api.requestResubmitRegistration(credentials, {});
      await dispatch('fetchAccountRegistrationStatus');
    }
  },

  async deleteSmsRegistration({ state, rootState }) {
    const registrationResponse = state.registrationResponse;
    if (registrationResponse.status === REGISTRATION_STATUS.BRAND_DELETED || registrationResponse.status === REGISTRATION_STATUS.BRAND_ERROR_IN_BILLING) {
      const credentials = rootState.credentials;
      await api.deleteAccountRegistration(credentials);
    }
  },
  async loadCatalog({ rootState, commit }) {
    try {
      const accountCatalog = await getAccountCatalog(rootState.credentials);
      const campaignCatalogRatePlanId = getCampaignCatalogRatePlanId(accountCatalog.data, false);
      const campaignCatalogRateSPPlanId = getCampaignCatalogRatePlanId(accountCatalog.data, true);
      const brandCatalogRatePlanId = getBrandCatalogRatePlanId(accountCatalog.data);
      const isSoleProprietor = rootState.smsRegistrations?.registrationResponse?.vonage_api_brand_request?.entity_type === BRAND_ENTITY_TYPES.SOLE_PROPRIETOR;
      if (!campaignCatalogRatePlanId || !brandCatalogRatePlanId || (!campaignCatalogRateSPPlanId && isSoleProprietor) ||
        !campaignCatalogRatePlanId.productRatePlanId || !brandCatalogRatePlanId.productRatePlanId
      || (!campaignCatalogRateSPPlanId?.productRatePlanId && isSoleProprietor)) {
        commit('SET_CATALOG_MISSING', true);
      }
    } catch (error) {
      console.error('[loadCatalog] Error loading catalog:', error.message);
      commit('SET_CATALOG_MISSING', true);
    }
  },
  async retrySubmitRegistrationOnBillingError({ rootState, dispatch }) {

    const paymentMethods = await getPaymentMethods(rootState.credentials);
    const paymentMethodId = getDefaultPaymentMethod(paymentMethods.data).id;
    const accountCatalog = await getAccountCatalog(rootState.credentials);
    const isSoleProprietor = rootState.smsRegistrations.registrationResponse?.vonage_api_brand_request?.entity_type === 'SOLE_PROPRIETOR';
    const campaignCatalogRatePlanId = getCampaignCatalogRatePlanId(accountCatalog.data, isSoleProprietor);
    const brandCatalogRatePlanId = getBrandCatalogRatePlanId(accountCatalog.data);
    const isMultiLocationAccount = rootState.accountDetails.Locations.length > 1;
    const brandBillingObj = buildBillingObject(rootState.accountDetails, rootState.credentials.accountId, isMultiLocationAccount, get(brandCatalogRatePlanId, 'productRatePlanId'), paymentMethodId);
    const campaignBillingObj = buildBillingObject(rootState.accountDetails, rootState.credentials.accountId, isMultiLocationAccount, get(campaignCatalogRatePlanId, 'productRatePlanId'), paymentMethodId);

    await api.updateAccountBilling(rootState.credentials, {
      campaign_billing_request: campaignBillingObj,
      brand_billing_request: brandBillingObj,
    });
    await dispatch('fetchAccountRegistrationStatus')
  },

  async updateQuickFlowCampaign({ rootState, getters, dispatch }, {registrationDetails, messagingDescription,  messageContent}) {

    const brandObject = {
      company_name: registrationDetails.companyName,
      display_name: registrationDetails.displayName,
      entity_type: registrationDetails.entityType,
      ein: registrationDetails.ein,
      website: registrationDetails.website.trim(),
      vertical: registrationDetails.vertical,
      street: registrationDetails.street,
      city: registrationDetails.city,
      state: registrationDetails.state,
      postal_code: registrationDetails.postalCode,
      country: registrationDetails.country,
      phone: registrationDetails.e164.substring(1), // without '+'
      email: registrationDetails.email,
    };

    if (registrationDetails.entityType === 'SOLE_PROPRIETOR') {
      brandObject.first_name = registrationDetails.firstName;
      brandObject.last_name = registrationDetails.lastName;
      brandObject.mobile_phone = registrationDetails.mobilePhone;
    } else {
      brandObject.ein = registrationDetails.ein;

      if (registrationDetails.entityType === 'PUBLIC_PROFIT') {
        brandObject.stock_exchange = registrationDetails.stockExchange;
        brandObject.stock_symbol = registrationDetails.stockSymbol;
        brandObject.verification_email = registrationDetails.verificationEmail;
      }
    }

    let usecase = getters.registrationResponse.vonage_api_campaign_request.usecase ?? process.env.VUE_APP_CAMPAIGN_LOW_USE_CASE;

    const campaignObject = buildCampaignObject(messagingDescription, messageContent, registrationDetails.companyName, registrationDetails.displayName, registrationDetails.vertical, usecase, registrationDetails.entityType)

    supportMessagingDescriptionV2(messagingDescription);
    await api.updateQuickFlowCampaign(rootState.credentials, {
      brand_request: brandObject,
      campaign_request: campaignObject,
      messaging_description_page : messagingDescription,
      message_content_page : messageContent
    });
    await dispatch('fetchAccountRegistrationStatus');
  },

  async createSharedRegistration({ rootState }, { shareRegistrationData}) {
    try {
      let response = await api.createSharedRegistration(rootState.credentials, {
        main_account_id: shareRegistrationData.mainAccountId.trim(),
        main_account_tcr_brand_id: shareRegistrationData.mainAccountBrandId.trim()
      });
      return {
        data: response.data,
        success: true
      }
    } catch (e) {
      return {
        data: e.response.data,
        success: false
      }
    }
  },

  setBulkSmsFeatureFlag({ commit }, value) {
    commit('SET_BULK_SMS_FEATURE_FLAG', value);
  },

  async performFullSync({ rootState }){
    await api.requestFullSync(rootState.credentials);
  },

  async uploadRegistrationFile({ rootState }, formData) {
    await api.uploadFile(rootState.credentials, formData);
  },
  async fetchAndExport({rootState}){
    const { data: number_pooling_data_list }= await api.fetchAndExportNumberPooling(rootState.credentials);
    return number_pooling_data_list;
  },

  async deleteTheSmsRegistration({ rootState }){
    await api.deleteSmsRegistration(rootState.credentials)
      .then(async () => {
        try {
          window.location.reload();
        } catch (statusError) {
          console.warn('Failed to fetch updated status after deletion:', statusError);
        }
        return { success: true };
      })
      .catch(error => {
        console.error('Failed to delete registration:', error);
        throw error;
      });
  },
  async setCancelRegistrationStatus({rootState}){
    await api.cancelAccountRegistration(rootState.credentials)
      .then(async () => {
        try {
          window.location.reload();
        } catch (statusError) {
          console.warn('Failed to fetch updated status after cancellation:', statusError);
        }
        return { success: true };
      })
      .catch(error => {
        console.error('Failed to cancel registration:', error);
        throw error;
      });
  },

  setShownEditView({state, commit}, val) {
    if (!state.isVoluntaryEditEnabled && val === EDIT_FORM_VIEW_TYPE.EDIT) {
      // this should never happen but check just in case user tried to cheat the app
      console.error('Tried to open edit view but the voluntary edit was disabled.');
      return;
    }
    commit('SET_SHOWN_EDIT_VIEW',val)
  },
  async checkSpFlagForUser({ rootState, commit }) {
    if(!isSPAccountsAccessible()){
      await flagApi.getFeatureFlag(rootState.credentials, "SP")
          .then(flagReturn => commit('FETCHED_SP_FLAG', flagReturn.data));
    }
    else{
      commit('FETCHED_SP_FLAG', true);
    }
  },

  async checkSpEditFlagForUser({ rootState, commit }) {
    if(!isSPAccountsAccessible()){
      await flagApi.getFeatureFlag(rootState.credentials, "SP_EDIT")
          .then(flagReturn => commit('FETCHED_SP_EDIT_FLAG', flagReturn.data));
    }
    else{
      commit('FETCHED_SP_EDIT_FLAG', true);
    }
  },

  selectSoleProprietorNumber({ rootState, dispatch }, phoneNumber) {
    return api.selectSoleProprietorNumber(rootState.credentials, phoneNumber)
        .then(() => {
          // Fetch updated status but don't fail the whole operation if it fails
          dispatch('fetchAccountRegistrationStatus').catch(() => {});
          return { success: true };
        })
        .catch(error => Promise.reject(error));
  },


  changeAccountNeedToResubmit({commit},val) {
    commit('ACCOUNT_NEED_RESUBMIT',val)
  },
  reregister({commit},val){
    commit('REREGISTER',val)
  },

  toggleShowRequiredChanges({commit},val) {
    commit('TOGGLE_REQUIRED_CHANGES',val)
  },

  async fetchSinchApprovalPending({ rootState, commit }) {
      const response = await api.getSinchApprovalPending(rootState.credentials);
      commit('SET_SINCH_APPROVAL_PENDING', !!response.data);
  },

  async enableSinchNumberPool({ rootState }) {
    await api.enableSinchNumberPool(rootState.credentials);
  },

};
export default actions;
